
export function About() {
  const values = [
    {
      icon: 'ri-star-smile-line',
      title: 'Empower Artists',
      description: 'アーティストの可能性を最大化する。\n戦略・機会創出・グローバル展開を通じて、才能を"評価される存在"へと引き上げる。'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Elevate Fan Experience',
      description: 'ファン体験の価値を進化させる。\n観るだけではなく、参加し、共鳴し、共に成長する。ファンを"消費者"から"共創者"へ。'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Build the Platform for Impact',
      description: 'アーティストの認知拡大・話題創出・新規獲得を加速させる革新的なエンターテインメントプラットフォームを創る。'
    }
  ];

  const skills = [
    '企画設計・イベントプロデュース',
    '認知拡張プロモーション戦略', 
    '英語／中国語対応グローバル連携',
    'VIP・ステークホルダーマネジメント',
    'SNS成長設計・アルゴリズム分析'
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-black relative overflow-hidden">
      <div className="absolute top-0 left-0 w-48 md:w-96 h-48 md:h-96 bg-pink-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-48 md:w-96 h-48 md:h-96 bg-purple-500/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-blue-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 md:px-6 py-2 rounded-full bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 border border-pink-500/30 text-pink-400 text-sm font-semibold tracking-wider mb-4 md:mb-6">
            OUR PHILOSOPHY
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            私たちの<span className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">理念</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            <span className="block sm:inline">アーティストとファン、</span>
            <span className="block sm:inline">両方が幸せになるエンタメ体験を。</span>
            <span className="block sm:hidden mt-1">それが私たちの使命です。</span>
            <span className="hidden sm:inline">それが私たちの使命です。</span>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 mb-16 md:mb-20">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-gray-900/80 to-gray-900/40 rounded-2xl md:rounded-3xl p-6 md:p-8 border border-gray-800 hover:border-pink-500/50 transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-b from-pink-500/5 via-purple-500/5 to-blue-500/5 rounded-2xl md:rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-xl md:rounded-2xl bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 mb-4 md:mb-6">
                  <i className={`${value.icon} text-2xl md:text-3xl bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent`} style={{ WebkitTextFillColor: 'transparent', WebkitBackgroundClip: 'text' }}></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4">{value.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm md:text-base whitespace-pre-line">{value.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="relative rounded-3xl md:rounded-[40px] overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20"></div>
          <div className="relative bg-gray-900/90 backdrop-blur-sm p-8 md:p-12 lg:p-16">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
              <div className="flex-shrink-0 order-2 lg:order-1">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 rounded-full blur-2xl opacity-20"></div>
                  <div className="relative w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40">
                    <img
                      src="https://static.readdy.ai/image/958f03ddcb24e17d7d702f4881f49ed8/bbe3b1c27ed4488c70ce100d708a113a.jpeg"
                      alt="Logo"
                      className="w-full h-full object-contain rounded-xl md:rounded-2xl"
                      style={{ mixBlendMode: 'screen', filter: 'brightness(1.2)' }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
                <div className="space-y-4 md:space-y-6">
                  <p className="text-xl md:text-2xl lg:text-3xl xl:text-4xl text-white font-light leading-relaxed tracking-wide">
                    <span className="text-pink-400 font-medium">Unique</span>
                    <span className="text-gray-300">（アーティスト）</span>と、
                    <br className="hidden sm:block" />
                    <span className="text-purple-400 font-medium">Unity</span>
                    <span className="text-gray-300">（ファンダム）</span>を守り、
                    <br className="hidden sm:block" />
                    共に成長し、
                    <span className="text-blue-400 font-medium">U&nbsp;</span>
                    という笑顔を届ける。
                  </p>
                  <div className="w-16 md:w-24 h-0.5 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 mx-auto lg:mx-0"></div>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base lg:text-lg max-w-2xl">
                    私たちのロゴには、アーティストとファンの「一体感」と、それぞれの「個性」を大切に守りながら、すべての人に笑顔を届けたいという想いが込められています。
                  </p>
                  
                  {/* Skills Tags */}
                  <div className="flex flex-wrap gap-2 md:gap-3 justify-center lg:justify-start pt-4">
                    {skills.map((skill, index) => (
                      <span
                        key={index}
                        className="px-3 md:px-4 py-2 bg-gradient-to-r from-gray-800 to-gray-700 border border-gray-600 rounded-full text-xs md:text-sm text-gray-300 font-medium"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
